var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"value":true,"color":"error","icon":"warning"}},[_vm._v(" Sorry, nothing to display here :( ")])}
var staticRenderFns = []

export { render, staticRenderFns }